import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from './components/ui/sonner';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import Portfolio from './pages/Portfolio';
import Contact from './pages/Contact';
import { useEffect } from "react";

function App() {
  useEffect(() => {
    const removeEmergent = () => {
      document
        .querySelectorAll('[class*="emergent"], [id*="emergent"]')
        .forEach(el => el.remove());
    };

    removeEmergent();
    setInterval(removeEmergent, 1000);
  }, []);
  return (
    <>
      <BrowserRouter>
        <Header />

        <main id="main-content">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/portfolio" element={<Portfolio />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
        </main>

        <Footer />
        <Toaster />
      </BrowserRouter>
    </>
  );
}

export default App;
